import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"

export function PopoverPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Popover</h1>
      </header>

      <Section title="Trigger opens a small panel">
        <Popover>
          <PopoverTrigger asChild>
            <Button>Open popover</Button>
          </PopoverTrigger>
          <PopoverContent>
            <h3 className="text-body-sm font-semibold text-text">Filter</h3>
            <p className="mt-1.5 text-caption text-text-2">
              A short panel of content. Focus moves in until dismissed.
            </p>
          </PopoverContent>
        </Popover>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
